import { createZodDto } from "nestjs-zod/dto";
import z from "zod";
import { userSchema } from "../user";

export const creditTraductionSchema = z.object({
  id: z.string(),
  quantity: z.number(),
  remain: z.number(),
  souscriptionId: z.string().optional().nullable(),
  userId: z.string(),
  user: userSchema.optional(),
  updatedAt: z.coerce.date(),
});

export class CreditTraductionDto extends createZodDto(creditTraductionSchema) {}
